var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-button',{attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }